import { BarChart, ManageAccounts, PeopleAlt, Archive, Workspaces } from '@mui/icons-material';
import { Box, Grid } from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import './adminconsole.css';
import { AdminConsoleCardItem, AdminConsoleCardItemProps } from './AdminConsoleCardItem';
import { AdminConsolePanel } from './AdminConsolePanel';
import { AdminConsoleSupport } from './AdminConsoleSupport';



export const AdminConsole = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { nameOrg } = useParams();

    const AdminConsoleCardItemList: AdminConsoleCardItemProps[] = [
        {
            iconTitle: BarChart,
            title: t("Sidebar.Dashboard"),
            description: t("AdminConsole.DashboardSubtitle"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/dashboard`),
        },
        {
            iconTitle: ManageAccounts,
            title: t("AdminConsole.AccountAndSubscription"),
            description: t("AdminConsole.ManageYourAccountAndSubscriptionEnsuringFullControlOverImportantSettings"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/accountAndSubscription`),
        },
        {
            iconTitle: PeopleAlt,
            title: t("AdminConsole.UsersAndGroups"),
            description: t("AdminConsole.EfficientlyLearnAboutUsersAndGroupsToFacilitateCollaborationAccessControlAndPermissions"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/usersAndGroups`),
        },
        {
            iconTitle: Workspaces,
            title: "Workspaces",
            description: t("AdminConsole.CheckOutAndManageOrganizationsViewingDetailsLikeStorageAndSettings"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/workspaces`),
        },
        {
            iconTitle: Archive,
            title: t("AdminConsole.Plans"),
            description: t("AdminConsole.BrowseTheAvailablePlansCompareFeaturesAndChooseTheBestOptionForYourNeeds"),
            seeMoreAction: () => navigate(`/${nameOrg}/adminConsole/plans`),
        },
    ]

    return (
        <div style={{
            height: "100%",
            backgroundColor: '#F7F8FA',
        }}>
            <Box sx={{
            padding: '15px 30px',
            display: 'flex',
            gap: '20px',
            backgroundColor: '#F7F8FA',
            
        }}>
            <Grid container columnSpacing="20px" rowSpacing="20px">
                <Grid item xs={12}>
                    <AdminConsolePanel />
                </Grid>
                {AdminConsoleCardItemList.map(cardItem => {
                    return (
                        <Grid item xs={6}>
                            <AdminConsoleCardItem
                                description={cardItem.description}
                                iconTitle={cardItem.iconTitle}
                                seeMoreAction={cardItem.seeMoreAction}
                                title={cardItem.title}
                            />
                        </Grid>
                    )
                })}
            </Grid>
            <AdminConsoleSupport />
        </Box>
        </div>
    )
}

